<template>
  <div class="app-container asset-todo-workbench">
    <div class="workbench-header">
      <div>
        <h3>资产待处理</h3>
      </div>
      <el-button icon="el-icon-refresh" @click="refreshCurrent">刷新当前页</el-button>
    </div>

    <el-tabs v-model="activeTab" class="workbench-tabs" @tab-click="handleTabClick">
      <el-tab-pane name="todo" lazy>
        <span slot="label">
          待处理
          <el-badge v-if="todoCount" :value="todoCount" :max="99" class="tab-badge" />
        </span>
        <asset-todo ref="todo" @change-tab="switchTab" @count-change="todoCount = $event" />
      </el-tab-pane>
      <el-tab-pane label="领用申请" name="claim" lazy>
        <asset-claim ref="claim" />
      </el-tab-pane>
      <el-tab-pane label="报修报废" name="repair" lazy>
        <asset-repair ref="repair" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import AssetTodo from './todo'
import AssetClaim from './claim'
import AssetRepair from './repair'

const VALID_TABS = ['todo', 'claim', 'repair']

export default {
  name: 'CrmAssetTodoWorkbench',
  components: { AssetTodo, AssetClaim, AssetRepair },
  data() {
    const requested = this.$route.query.tab
    return {
      activeTab: VALID_TABS.includes(requested) ? requested : 'todo',
      todoCount: 0
    }
  },
  watch: {
    '$route.query.tab'(value) {
      const next = VALID_TABS.includes(value) ? value : 'todo'
      if (next !== this.activeTab) this.activeTab = next
    }
  },
  methods: {
    handleTabClick(tab) {
      this.syncRoute(tab.name)
      this.refreshTab(tab.name)
    },
    switchTab(name) {
      if (!VALID_TABS.includes(name)) return
      this.activeTab = name
      this.syncRoute(name)
      this.$nextTick(() => this.refreshTab(name))
    },
    syncRoute(name) {
      if (this.$route.query.tab === name) return
      this.$router.replace({ path: this.$route.path, query: Object.assign({}, this.$route.query, { tab: name }) })
    },
    refreshCurrent() {
      this.refreshTab(this.activeTab)
    },
    refreshTab(name) {
      const component = this.$refs[name]
      if (!component) return
      const methodMap = {
        todo: 'loadList',
        claim: 'loadList',
        repair: 'getList'
      }
      const method = methodMap[name]
      if (method && typeof component[method] === 'function') component[method]()
    }
  }
}
</script>

<style lang="scss" scoped>
.asset-todo-workbench {
  padding-top: 18px;
}

.workbench-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  h3 {
    margin: 0;
    font-size: 22px;
    color: #303133;
  }
}

.workbench-tabs {
  ::v-deep > .el-tabs__header {
    margin-bottom: 0;
    padding: 0 18px;
    border: 1px solid #e4e7ed;
    border-bottom: 0;
    border-radius: 8px 8px 0 0;
    background: #fff;
  }

  ::v-deep > .el-tabs__content {
    min-height: 540px;
    border: 1px solid #e4e7ed;
    border-radius: 0 0 8px 8px;
    background: #fff;
  }

  ::v-deep .el-tabs__item {
    height: 52px;
    line-height: 52px;
    font-size: 15px;
  }

  ::v-deep .app-container {
    padding: 18px;
  }
}

.tab-badge {
  margin-left: 5px;

  ::v-deep .el-badge__content {
    position: static;
    transform: none;
  }
}
</style>
